var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestFormFormGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 60,
    viewBox: "0 0 52 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "request_form-form-green",
    "data-name": "request form-form-green",
    transform: "translate(-6 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 11,
    height: 2,
    transform: "translate(10 6)",
    fill: "#34b2b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M11,24h9a1,1,0,0,0,1-1V19a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1v4A1,1,0,0,0,11,24Zm1-4h7v2H12Z",
    fill: "#34b2b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M24,24H45a1,1,0,0,0,1-1V19a1,1,0,0,0-1-1H24a1,1,0,0,0-1,1v4A1,1,0,0,0,24,24Zm1-4H44v2H25Z",
    fill: "#34b2b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M11,16h9a1,1,0,0,0,1-1V11a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1v4A1,1,0,0,0,11,16Zm1-4h7v2H12Z",
    fill: "#34b2b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M24,16H45a1,1,0,0,0,1-1V11a1,1,0,0,0-1-1H24a1,1,0,0,0-1,1v4A1,1,0,0,0,24,16Zm1-4H44v2H25Z",
    fill: "#34b2b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 12,
    height: 2,
    transform: "translate(10 26)",
    fill: "#34b2b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M55.768,22.435a3.313,3.313,0,0,0-4.213,2.047l-.76,2.19h0l-.8,2.3V3a1,1,0,0,0-1-1H7A1,1,0,0,0,6,3V61a1,1,0,0,0,1,1H49a1,1,0,0,0,1-1V49.247l7.065-20.41h0l.745-2.176a3.193,3.193,0,0,0,.19-1.1A3.308,3.308,0,0,0,55.768,22.435Zm-1.656,1.948a1.292,1.292,0,0,1,1-.057A1.308,1.308,0,0,1,56,25.56a1.222,1.222,0,0,1-.076.436L55.5,27.238l-1.243-.428-1.243-.429.432-1.243a1.308,1.308,0,0,1,.666-.755ZM44,46.317,43.418,48H12V32H44ZM48,60H8V4H48V34.752l-2,5.782V31a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1V49a1,1,0,0,0,1,1H42.727l-.752,2.184a.971.971,0,0,0-.016.531h-.018l.927,4.4a1,1,0,0,0,.652.739.962.962,0,0,0,.326.055,1,1,0,0,0,.642-.233l3.448-2.889-.01-.011c.024-.02.052-.034.074-.056Zm-3.739-5.969,1.039.359-.819.686Zm2.411-1.283-2.481-.857,8.168-23.62,2.489.858Z",
    fill: "#34b2b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 22,
    height: 2,
    transform: "translate(11 52)",
    fill: "#34b2b0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestFormFormGreen);
export default __webpack_public_path__ + "static/media/request_form-form-green.c428da0b31ac351b57cae09ea9af873e.svg";
export { ForwardRef as ReactComponent };